import type { PhaseProcedurale } from "@/types/procedure";

interface Props {
  phase: PhaseProcedurale;
}

/**
 * Bandeau « dossier dessaisi » — affiché quand le tribunal s'est déclaré
 * incompétent (exception d'incompétence admise, L8). La phase DESSAISI est
 * terminale : la procédure est gelée (plus aucune mutation d'acte possible).
 */
export function DessaisiBadge({ phase }: Props) {
  if (phase !== "DESSAISI") return null;
  return (
    <div className="flex items-center gap-2 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
      <span className="shrink-0 rounded-full bg-red-600 px-2 py-0.5 text-xs font-bold text-white">
        DESSAISI
      </span>
      <span>
        Le tribunal s'est déclaré incompétent : le dossier est dessaisi et la
        procédure gelée. Aucun nouvel acte ne peut être posé.
      </span>
    </div>
  );
}
